module.exports = __webpack_public_path__ + "static/media/imageUpload.ab825823.svg";